import * as Sentry from "@sentry/react";

const getShouldInitSentry = (env: string | undefined) => {
  return env === "production" || env === "staging";
};

if (getShouldInitSentry(`${import.meta.env.VITE_APP_ENVIRONMENT}`)) {
  Sentry.init({
    dsn: "https://1da2805e38404bb18f259ef1d57938ff@o192177.ingest.us.sentry.io/5975777",
    tracesSampleRate: 0,
    environment: `${import.meta.env.VITE_APP_ENVIRONMENT}`,
    release: `${import.meta.env.VITE_APP_RELEASE}`,
    beforeSend: (event) => {
      const exception = event.exception?.values && event.exception?.values[0];
      if (
        exception?.value?.startsWith(
          "Non-Error promise rejection captured with"
        )
      ) {
        return null;
      }
      return event;
    },
  });
}
